import React from "react";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { db } from "../firebase";
import LandingsManagerBase from "./LandingsManagerBase";
import LandingCombosMatrix from "./LandingCombosMatrix";
import { fetchPublicVenues, venuesForEventType } from "../utils/landingsInventory";

// Tipos de evento (FRA-286): cada doc alimenta la landing /{slugES} y
// /en/{slugEN} del homesite más la sección "por tipo de evento" del homepage.
// Los venues se taggean con estos ids desde su editor (FRA-287).

const SLUG_RE = /^[a-z0-9]+(-[a-z0-9]+)*$/;

const config = {
  collection: "eventTypes",
  title: "Tipos de Evento",
  singular: "tipo de evento",
  hasComboH1: true,
  subtitle:
    "Cada tipo activo publica su landing en /{slug} (y /en/{slug EN}) sin deploy. El orden es el que ven los usuarios en el homepage.",
  identityFields: [
    { path: "label.ES", label: "Nombre (ES)", placeholder: "Bodas" },
    { path: "label.EN", label: "Nombre (EN)", placeholder: "Weddings" },
    {
      path: "slug.ES",
      label: "Slug ES (URL)",
      placeholder: "bodas",
      hint: "URL pública: venueboard.com/{slug}",
      warnOnEdit:
        "Cambiar el slug de una landing publicada rompe la URL indexada (SEO).",
    },
    {
      path: "slug.EN",
      label: "Slug EN (URL)",
      placeholder: "weddings",
      hint: "URL pública: venueboard.com/en/{slug}",
      warnOnEdit:
        "Cambiar el slug de una landing publicada rompe la URL indexada (SEO).",
    },
    {
      path: "abrirMapa",
      label: "Abrir con mapa",
      type: "checkbox",
      checkboxLabel: "La landing abre con el mapa visible por default",
      hint: "Útil para tipos donde la ubicación pesa (p. ej. conferencias). Las landings de ubicación y los combos ya abren con mapa siempre.",
    },
  ],
  rowLabel: (d) => d.label?.ES || d.slug?.ES || "(sin nombre)",
  rowDetail: (d) => `/${d.slug?.ES || "?"} · /en/${d.slug?.EN || "?"}`,
  // Cuántos venues públicos mostraría la landing de cada tipo (tag explícito).
  loadCounts: async (items) => {
    const venues = await fetchPublicVenues();
    return Object.fromEntries(
      items.map((i) => [i.id, venuesForEventType(venues, i.id).length])
    );
  },
  belowList: <LandingCombosMatrix />,
  newDraft: () => ({
    slug: { ES: "", EN: "" },
    label: { ES: "", EN: "" },
    icono: "",
    activo: false,
    abrirMapa: false,
    orden: 999,
    homeDesc: { ES: "", EN: "" },
    landing: { ES: null, EN: null },
  }),
  docIdFor: (draft) => draft.slug.ES,
  validateDraft: (draft) => {
    if (!draft.label?.ES?.trim()) return "Falta el nombre en español";
    if (!SLUG_RE.test(draft.slug?.ES || ""))
      return "Slug ES inválido (minúsculas, números y guiones)";
    if (!SLUG_RE.test(draft.slug?.EN || ""))
      return "Slug EN inválido (minúsculas, números y guiones)";
    return null;
  },
  // No se puede borrar un tipo con venues tageados (FRA-286).
  canDelete: async (item) => {
    const snap = await getDocs(
      query(
        collection(db, "venues"),
        where("eventTypes", "array-contains", item.id),
        limit(1)
      )
    );
    if (!snap.empty) {
      return `Hay venues tageados con "${item.label?.ES}". Quita el tag de esos venues antes de eliminarlo, o desactívalo.`;
    }
    return null;
  },
};

export default function EventTypesManager() {
  return <LandingsManagerBase config={config} />;
}
